import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'
import {shallowEqual, useSelector} from 'react-redux'
// @ts-ignore
import Toastify from 'toastify-js'
import 'toastify-js/src/toastify.css'
import React from 'react'
import {useIntl} from 'react-intl'
import {RootState} from '../../setup'
import {serialize} from 'object-to-formdata'
import moment from 'moment/moment'
import {CurrencyUtils} from './CurrencyUtils'

export function useCheckAccess() {
  const accesses = useSelector<RootState>(({auth}) => auth.accesses, shallowEqual)
  const user: any = useSelector<RootState>(({auth}) => auth.user, shallowEqual)
  const isRoot = user?.is_root || user?.group?.id === 1
  return (module: any) => {
    if (isRoot) return true
    if (accesses) {
      // @ts-ignore
      return accesses.includes(module)
    }
    return false
  }
}

export function CheckAccess(module: any) {
  const accesses = useSelector<RootState>(({auth}) => auth.accesses, shallowEqual)
  const user: any = useSelector<RootState>(({auth}) => auth.user, shallowEqual)
  const isRoot = user?.is_root || user?.group?.id === 1
  if (isRoot) return true
  if (accesses) {
    // @ts-ignore
    return accesses.includes(module)
  }
  return false
}

export function useCheckDashboardAccesses() {
  const user: any = useSelector<RootState>(({auth}) => auth.user, shallowEqual)
  const isRoot = user?.is_root || user?.group?.id === 1
  return (country: string) => {
    if (isRoot) return true
    if (user) {
      return user?.working_location?.split(',')?.includes(country)
    }
    return false
  }
}

export function CheckDashboardAccesses(country: string) {
  const user = useSelector<RootState>(({auth}) => auth.user, shallowEqual)
  if (user) {
    // @ts-ignore
    return user?.working_location?.split(',')?.includes(country)
  }
  return false
}

export function useCheckModulesAccess() {
  const accesses = useSelector<RootState>(({auth}) => auth.accesses, shallowEqual)
  const user: any = useSelector<RootState>(({auth}) => auth.user, shallowEqual)
  const isRoot = user?.is_root || user?.group?.id === 1
  return (modules: string[]) => {
    if (isRoot) return true
    if (accesses) {
      // @ts-ignore
      return accesses.some((ai: any) => modules.includes(ai))
    }
    return false
  }
}

export function CheckModulesAccess(modules: string[]) {
  const accesses = useSelector<RootState>(({auth}) => auth.accesses, shallowEqual)
  const user: any = useSelector<RootState>(({auth}) => auth.user, shallowEqual)
  const isRoot = user?.is_root || user?.group?.id === 1
  if (isRoot) return true
  if (accesses) {
    // @ts-ignore
    return accesses.some((ai) => modules.includes(ai))
  }
  return false
}

export function useIsRootUserOrAdmin() {
  const user: any = useSelector<RootState>(({auth}) => auth.user, shallowEqual)
  return user?.is_root || user?.group?.id === 1
}

export function IsRootUserOrAdmin() {
  const user: any = useSelector<RootState>(({auth}) => auth.user, shallowEqual)
  return user?.is_root || user?.group?.id === 1
}

export const handleNotificationPrompt = (
  title: any,
  message: any,
  icon: any,
  history?: any,
  redirect_to: any = ''
) => {
  Swal.fire({
    title: title,
    html: message,
    icon: icon,
    allowOutsideClick: false,
  }).then(() => {
    Swal.close()
    if (redirect_to !== '') {
      history.push(redirect_to)
    }
  })
}

export const handleNotificationWithToastify = (
  data: any,
  history: any = null,
  redirect_to: any = ''
) => {
  Toastify({
    text: data.message,
    duration: 3000,
    newWindow: true,
    gravity: 'top',
    position: 'right',
    className: data?.success ? 'toastify-info' : 'toastify-error',
    stopOnFocus: true,
    onClick: function () {
      if (redirect_to !== '') {
        history.push(redirect_to)
      }
    },
  }).showToast()
}

export const SYSTEM_MODULES = {
  navigation: {
    bookings: {
      booking: [
        'bookings.index',
        // 'bookings.create',
        'bookings.show',
        'bookings.edit',
        'bookings.delete',
        'bookings.voucher_no_payment',
        'bookings.activity_log',
        'bookings.export',
        'bookings.view_financials',
        'bookings.process',
        'bookings.cancel',
        'bookings.voucher',
        'bookings.show_own',
        'bookings.show_all',
        'bookings.add_markup',
      ],
      quotation: [
        'quotations.index',
        'quotations.create',
        'quotations.show',
        'quotations.edit',
        'quotations.delete',
        'quotations.last_3_months',
        'quotations.export',
        'quotations.view_financials',
        'quotations.show_own',
        'quotations.show_all',
        'quotations.add_markup',
      ],
    },

    dashboard_and_analytics: {
      dashboard: [
        'dashboard.show_own',
        'dashboard.show_all',
        'dashboard.hotels',
        'dashboard.services',
      ],
      statistics: [
        'statistics.index',
        'statistics.overview',
        'statistics.bookings',
        'statistics.revenue',
        'statistics.daily_sales',
        'statistics.daily_operations',
        'statistics.operations_dashboard',
        'statistics.payments',
      ],
      agent_portal: ['agent_portal.index', 'agent_portal.export'],
      calendar: ['calendar.index'],
    },

    hotels: {
      hotel: [
        'hotels.index',
        'hotels.create',
        'hotels.show',
        'hotels.edit',
        'hotels.delete',
        'hotels.export',
      ],
      hotel_main_contract: [
        'hotels.markup.view',
        'hotels.markup.create',
        'hotels.markup.edit',
        'hotels.markup.delete',
      ],
      hotel_promotions: [
        'hotels.promotions.view',
        'hotels.promotions.create',
        'hotels.promotions.edit',
        'hotels.promotions.delete',
      ],
      hotel_daily_prices: ['hotels.daily_prices.view', 'hotels.daily_prices.edit'],
      hotel_rooms: [
        'hotels.rooms.view',
        'hotels.rooms.create',
        'hotels.rooms.edit',
        'hotels.rooms.delete',
      ],
      hotel_stop_sales: ['hotels.stop_sales.view', 'hotels.stop_sales.edit'],
      hotel_allotment: ['hotels.allotment.view', 'hotels.allotment.edit'],
      hotel_amenity: [
        'hotel_amenities.index',
        'hotel_amenities.create',
        'hotel_amenities.show',
        'hotel_amenities.edit',
        'hotel_amenities.delete',
      ],
      hotel_area: [
        'hotel_areas.index',
        'hotel_areas.create',
        'hotel_areas.show',
        'hotel_areas.edit',
        'hotel_areas.delete',
      ],
      hotel_brand: [
        'hotel_brands.index',
        'hotel_brands.create',
        'hotel_brands.show',
        'hotel_brands.edit',
        'hotel_brands.delete',
      ],
      room_amenity: [
        'room_amenities.index',
        'room_amenities.create',
        'room_amenities.show',
        'room_amenities.edit',
        'room_amenities.delete',
      ],
      master_hotel: [
        'master_hotels.index',
        'master_hotels.create',
        'master_hotels.show',
        'master_hotels.edit',
        'master_hotels.delete',
      ],
    },

    services: {
      transfer: [
        'transfers.index',
        'transfers.create',
        'transfers.show',
        'transfers.edit',
        'transfers.delete',
        'transfers.export',
      ],
      sight_seeing: [
        'sight_seeings.index',
        'sight_seeings.create',
        'sight_seeings.show',
        'sight_seeings.edit',
        'sight_seeings.delete',
        'sight_seeings.stop_sale',
        'sight_seeings.export',
      ],
      package: [
        'packages.index',
        'packages.create',
        'packages.show',
        'packages.edit',
        'packages.delete',
      ],
    },

    agents_and_sales: {
      agent: [
        'agents.index',
        'agents.create',
        'agents.show',
        'agents.edit',
        'agents.delete',
        'agents.export',
      ],
      agent_wallet: ['agents.wallet'],
      supplier: [
        'suppliers.index',
        'suppliers.create',
        'suppliers.show',
        'suppliers.edit',
        'suppliers.delete',
      ],
      supplier_type: [
        'supplier_types.index',
        'supplier_types.create',
        'supplier_types.show',
        'supplier_types.edit',
        'supplier_types.delete',
      ],
      trade_show: [
        'trade_shows.index',
        'trade_shows.create',
        'trade_shows.show',
        'trade_shows.edit',
        'trade_shows.delete',
      ],
    },

    hr: {
      user: ['users.index', 'users.create', 'users.show', 'users.edit', 'users.delete'],
      leave: [
        'leaves.index',
        'leaves.create',
        'leaves.show',
        'leaves.edit',
        'leaves.delete',
        'leaves.approved',
      ],
      leave_type: [
        'leave_types.index',
        'leave_types.create',
        'leave_types.edit',
        'leave_types.delete',
      ],
      attendance: [
        'attendances.index',
        // 'attendances.create',
        'attendances.show',
        'attendances.edit',
        'attendances.delete',
      ],
      holiday: [
        'holidays.index',
        'holidays.create',
        'holidays.show',
        'holidays.edit',
        'holidays.delete',
      ],
    },

    lookups: {
      country: [
        'countries.index',
        'countries.create',
        'countries.show',
        'countries.edit',
        'countries.delete',
      ],
      city: ['cities.index', 'cities.create', 'cities.show', 'cities.edit', 'cities.delete'],
      airport: [
        'airports.index',
        'airports.create',
        'airports.show',
        'airports.edit',
        'airports.delete',
      ],
      pier: ['piers.index', 'piers.create', 'piers.show', 'piers.edit', 'piers.delete'],
      currency: [
        'currencies.index',
        'currencies.create',
        'currencies.show',
        'currencies.edit',
        'currencies.delete',
      ],
      document_type: [
        'document_types.index',
        'document_types.create',
        'document_types.show',
        'document_types.edit',
        'document_types.delete',
      ],
      banner: ['banners.index', 'banners.create', 'banners.show', 'banners.edit', 'banners.delete'],
    },

    system: {
      group: ['groups.index', 'groups.create', 'groups.show', 'groups.edit', 'groups.delete'],
      configuration: ['configurations.index'],
    },

    reports: {
      hotel_purchase: ['reports.hotel_purchase'],
      transfer_purchase: ['reports.transfer_purchase'],
      sightseeing_purchase: ['reports.sightseeing_purchase'],
    },

    activity_log: {
      activity_log: [
        'activity_logs.hotels',
        'activity_logs.transfers',
        'activity_logs.sight_seeings',
        'activity_logs.packages',
        'activity_logs.agents',
        'activity_logs.bookings',
      ],
    },
  },
}

export function BackButton() {
  const navigate = useNavigate()
  return (
    <button
      className='btn btn-secondary'
      type='button'
      onClick={() => {
        navigate(-1)
        /*Swal.fire({
                  icon: 'warning',
                  title: 'Are you sure?',
                  text: 'The changes added would be lost, do you still want to exit?',
                  showCancelButton: true,
                  confirmButtonText: 'Yes',
                  cancelButtonText: 'No',
                  reverseButtons: true,
                  allowOutsideClick: false,
                }).then(result => {
                  if (result.isConfirmed) {
                    navigate(-1)
                  }
                })*/
      }}
    >
      Back
    </button>
  )
}

export function BackButtonForDetailPage({path = ''}) {
  const navigate = useNavigate()
  return (
    <button
      className='btn btn-outline-secondary'
      type='button'
      onClick={() => {
        path ? navigate(path) : navigate(-1)
      }}
    >
      Back
    </button>
  )
}

export function PurposeForm({type}: any) {
  const intl = useIntl()
  return (
    <div className='col-md-4'>
      <div className='card gutter-b'>
        <div className='card-body'>
          <p className='font-weight-bolder text-uppercase mb-10'>
            {intl.formatMessage({id: `PURPOSE.${type}.TITLE`})}
          </p>
          <p>{intl.formatMessage({id: `PURPOSE.${type}.DESCRIPTION`})}</p>
        </div>
      </div>
    </div>
  )
}

export function SubmitForm({handleSubmit, values}: any) {
  return (
    <div className='card gutter-b'>
      <div className='card-body pb-0'>
        <div className='row'>
          <div className='col-md-12'>
            <div className='form-group'>
              <button
                type='submit'
                name='submit'
                className='btn btn-primary me-2'
                onSubmit={() => handleSubmit()}
              >
                {values.id ? 'Update' : 'Create'}
              </button>
              <BackButton />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export const logoutPopup = (navigate: any) => {
  Swal.fire({
    icon: 'warning',
    title: 'Are you sure?',
    text: 'You want to logout?',
    showCancelButton: true,
    confirmButtonText: 'Yes',
    cancelButtonText: 'No',
    reverseButtons: true,
    allowOutsideClick: false,
  }).then((result) => {
    if (result.isConfirmed) {
      navigate('/logout')
    }
  })
}

export const handleManualChange = (handleChange: any, name: string, value: string) => {
  let event = {
    target: {
      name: name,
      value: value,
    },
  }
  handleChange(event)
}

export const manageLocation = (place: any, handleChange: any) => {
  if (place === undefined) {
    return false
  }
  handleManualChange(handleChange, `agent_address`, place.formatted_address)
  for (const component of place.address_components) {
    const componentType = component.types[0]
    switch (componentType) {
      case 'postal_code':
        handleManualChange(handleChange, `agent_pincode`, component.long_name)
        break

      case 'administrative_area_level_1':
        handleManualChange(handleChange, `agent_state`, component.long_name)
        break

      case 'administrative_area_level_2':
      case 'administrative_area_level_3':
        handleManualChange(handleChange, `agent_city`, component.long_name)
        break

      case 'country':
        handleManualChange(handleChange, `agent_country`, component.long_name)
        break
    }
  }
  // handleManualChange(handleChange, `latitude`, place.geometry.location.lat())
  // handleManualChange(handleChange, `longitude`, place.geometry.location.lng())
}

export const checkEmpty = (value: string) => {
  return value ? value : '-'
}
export const getRoomInclusion = (value: string | string[]) => {
  const getSingleInclusion = (singleValue: string) => {
    const upperValue = singleValue?.toUpperCase()
    switch (upperValue) {
      case 'ROOM':
        return 'Room Only'
      case 'BF':
        return 'Breakfast'
      case 'H/B':
        return 'Half Board'
      case 'F/B':
        return 'Full Board'
      default:
        return singleValue || '-'
    }
  }

  if (Array.isArray(value)) {
    if (value.length === 0) {
      return '-'
    }
    return value.map(getSingleInclusion).join(', ')
  }

  return getSingleInclusion(value)
}

export const serializeValueWithArray = (values: any) => {
  const options = {
    indices: true,
    nullsAsUndefineds: false,
    booleansAsIntegers: false,
    allowEmptyArrays: true,
  }
  return serialize(values, options)
}

export const AuthFooter = () => (
  <p className='hide_on_mobile' style={{position: 'absolute', bottom: '10px'}}>
    <span className='text-gray-800'>
      Copyright &copy; {new Date().getFullYear()}
      &nbsp; ATM DMC. All rights reserved.
    </span>
  </p>
)

export const getInitials = (name: any) => {
  name = !!name ? name.split(' ') : ['Amigo', 'Amigo']
  if (name.length > 2) {
    name = [name[0], name[name.length - 1]]
  }
  return name.length > 1
    ? name[0].substring(0, 1).toUpperCase() + name[1].substring(0, 1).toUpperCase()
    : name[0].substring(0, 1).toUpperCase()
}

export const convertBase64 = (file: any) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(file)
    fileReader.onload = () => {
      resolve(fileReader.result)
    }
    fileReader.onerror = (error) => {
      reject(error)
    }
  })
}

export const updateMarketOrder = (allMarkets: any[]) => {
  let markets: any[] = []
  if (allMarkets && allMarkets?.length !== 0) {
    if (allMarkets.includes('indian')) {
      markets.push('indian')
    }
    if (allMarkets.includes('subcontinent')) {
      markets.push('subcontinent')
    }
    if (allMarkets.includes('middleeast')) {
      markets.push('middleeast')
    }
    if (allMarkets.includes('worldwide')) {
      markets.push('worldwide')
    }
  }
  return markets
}

export const DisplayCopyButton = ({markets, market, setFieldValue, values}: any) => {
  if (markets.length >= 2) {
    if (market === 'subcontinent' && markets.includes('indian')) {
      return (
        <button
          className='btn btn-primary ms-2 btn-sm'
          onClick={(e) => {
            e.preventDefault()
            setFieldValue(`prices[${market}]`, values.prices.indian)
          }}
        >
          Copy
        </button>
      )
    } else if (market === 'middleeast') {
      const commonValues = markets.find((item: any) => ['indian', 'subcontinent'].includes(item))
      return (
        <button
          className='btn btn-primary ms-2 btn-sm'
          onClick={(e) => {
            e.preventDefault()
            setFieldValue(`prices[${market}]`, values.prices[commonValues])
          }}
        >
          Copy
        </button>
      )
    } else if (market === 'worldwide') {
      const commonValues = markets.find((item: any) =>
        ['indian', 'subcontinent', 'middleeast'].includes(item)
      )
      return (
        <button
          className='btn btn-primary ms-2 btn-sm'
          onClick={(e) => {
            e.preventDefault()
            setFieldValue(`prices[${market}]`, values.prices[commonValues])
          }}
        >
          Copy
        </button>
      )
    }
    return null
  } else {
    return null
  }
}

export function AddToCartSwalFire() {
  const Toast = Swal.mixin({
    toast: true,
    position: 'bottom-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
  })

  Toast.fire({
    icon: 'success',
    title: 'Add to cart successfully.',
  })
  return null
}

export function DateFormat(props: {items: any}) {
  return <div className={'text-muted'}>{moment(props.items).format('DD/MM/YYYY')}</div>
}

export function TimeFormat(props: {time: string}) {
  return <div className={'text-muted'}>{moment(props?.time, '"HH:mm:ss"').format('HH:mm A')}</div>
}

export function capitalizeFirstLetter(text: string) {
  return text.replace(/\b\w/g, function (char) {
    return char.toUpperCase()
  })
}

// Re-export CurrencyUtils for backward compatibility
export {CurrencyUtils}

/**
 * Cross-browser clipboard copy function that works on iOS Safari
 * For use AFTER async operations (like API calls)
 */
export const copyToClipboard = async (text: string): Promise<boolean> => {
  // Try the modern Clipboard API first
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch (err) {
      // Fall through to fallback method
    }
  }

  // Fallback for older browsers
  return copyToClipboardFallback(text)
}

/**
 * Fallback clipboard copy using textarea and execCommand
 */
const copyToClipboardFallback = (text: string): boolean => {
  const textArea = document.createElement('textarea')
  textArea.value = text

  // Styling to hide the textarea
  textArea.style.top = '0'
  textArea.style.left = '0'
  textArea.style.position = 'fixed'
  textArea.style.width = '2em'
  textArea.style.height = '2em'
  textArea.style.padding = '0'
  textArea.style.border = 'none'
  textArea.style.outline = 'none'
  textArea.style.boxShadow = 'none'
  textArea.style.background = 'transparent'
  textArea.contentEditable = 'true'
  textArea.readOnly = false

  document.body.appendChild(textArea)

  // iOS Safari specific selection
  if (navigator.userAgent.match(/ipad|iphone/i)) {
    const range = document.createRange()
    range.selectNodeContents(textArea)
    const selection = window.getSelection()
    if (selection) {
      selection.removeAllRanges()
      selection.addRange(range)
    }
    textArea.setSelectionRange(0, 999999)
  } else {
    textArea.focus()
    textArea.select()
  }

  let success = false
  try {
    success = document.execCommand('copy')
  } catch (err) {
    console.error('Failed to copy text: ', err)
  }

  document.body.removeChild(textArea)
  return success
}

/**
 * Copy to clipboard with async data fetch - works on iOS Safari
 * This initiates the clipboard operation synchronously during user gesture,
 * while the content is resolved asynchronously via Promise.
 *
 * @param dataPromise - A function that returns a Promise resolving to the text to copy
 */
export const copyToClipboardAsync = async (
  dataPromise: () => Promise<string>
): Promise<boolean> => {
  // Check if ClipboardItem with Promise is supported (iOS Safari 13.4+)
  if (navigator.clipboard && window.isSecureContext && typeof ClipboardItem !== 'undefined') {
    try {
      // Create ClipboardItem with a Promise - this must be done synchronously
      const clipboardItem = new ClipboardItem({
        'text/plain': dataPromise().then((text) => new Blob([text], {type: 'text/plain'})),
      })
      await navigator.clipboard.write([clipboardItem])
      return true
    } catch (err) {
      // Fall through to await-then-copy approach
      console.log('ClipboardItem approach failed, trying fallback:', err)
    }
  }

  // Fallback: await the data then try to copy
  try {
    const text = await dataPromise()
    return copyToClipboard(text)
  } catch (err) {
    console.error('Failed to copy:', err)
    return false
  }
}
